@if (!hidden()) {
  <div class="container" [class.disabled]="disabled()">
    <div
      class="radio size-{{ size() }}"
      [class.active]="active()"
      [class.invalid]="isInvalid()"
      [tabindex]="disabled() ? -1 : 0"
      (focusout)="touch.emit()"
      #radioElement
    ></div>

    @if (label(); as label) {
      <onyx-input-label
        variant="title"
        [label]="label"
        [disabled]="disabled()"
      ></onyx-input-label>
    }
  </div>
}
